import React from "react";
import { Navigate } from "react-router-dom";

export default function AdditionalPrepCounsel() {
  return <Navigate to="/AdditionalPrepWorksheet?role=Senior%20Junior%20Counsel" replace />;
}
